/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { CalculationId } from "../../commons/types/CalculationId";
import { WorkbookId } from "../../commons/types/WorkbookId";
import { SheetId } from "../../commons/types/SheetId";
import { CalculationType } from "./CalculationType";
export const Calculation = core.serialization.object({
    id: CalculationId,
    workbookId: WorkbookId,
    sheetId: SheetId,
    fieldKey: core.serialization.string(),
    type: CalculationType,
    value: core.serialization.number().optional(),
});
